<template>
  <section class="bg-terms">
    <div class="home">
      <HeaderGlobal :secondaryHeader="false" :qtSomos="qtSomos" />
      <!-- Page Content Desktop -->
      <div class="container-fluid">
        <div class="container container-content border-left-light pt-md-5 pb-5">
          <div class="row">
          <div @click="backToHome()" :style="this.$store.state.template.style.surveyBtnColor ? {background: this.$store.state.template.style.surveyBtnColor} : ''" class="back-icon">
            <img style="height: 25px;" src="/static/assets/img/back-to-home-icon.png">
          </div>
            <div class="col-lg-12 pl-md-5 pr-md-0 px-0">
                <div style="width: 100%;">
                  <h1 class="text-title-terms text-first-color mt-2 mb-4 font-weight-normal" style="text-align: center;">Termos de Uso e Privacidade</h1>
                </div>
              <div class="text-break terms-justify" :class="defaultTextColor ? 'text-black' : 'text-white'">
                <TermsDefault v-if="isDefaultTerms" />
                <Termos v-else :key="termosHtml" :html="termosHtml"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterGlobal :secondaryFooter="false" :qtSomos="qtSomos" />
    </div>
  </section>
</template>
<script>
import HeaderGlobal from "./HeaderGlobal.vue";
import FooterGlobal from "./FooterGlobal.vue";
import Termos from "./Termos";
import TermsDefault from "./TermsDefault";

export default {
  name: "Terms",
  components: {
    HeaderGlobal,
    FooterGlobal,
    Termos,
    TermsDefault
  },
  data: () => ({
      qtSomos: 0,
      termosHtml :""
  }),
  created() {
      this.qtSomos = this.$store.state.qtUsers;
      this.termosHtml = this.$store.state.TermsText;
  },
  beforeMount() {
    if (!this.$store.state.template.style) {
      this.$nextTick(() => {
        this.$router.push('home')
      })
    }
  },
  mounted() {},
  watch: {},
  computed: {
    isDefaultTerms() {
      return (this.$store.state.template.terms && this.$store.state.template.terms.defaultTerms)
    },
    defaultTextColor() {
      this.$store.state.template && this.$store.state.template.style.defaultTextColor ? this.$store.state.template.style.defaultTextColor : ''
    }
  },
  methods: {
    backToHome(){
      this.$router.push('/')
    }
  }
};
</script>

<style scoped>
.bg-terms {
  background-color: var(--bg-fallback-color);
  background-image: var(--bg-image); /* fallback */
  background-image: var(--bg-image), var(--bg-gradient-color); /* W3C */
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  background-attachment: fixed;
  min-height: 100vh;
}

@media screen and (min-width: 900px) {
  .terms-justify {
    text-align: justify;
  }
}
.text-title-terms{
  font-size: 3rem !important;
}

.back-icon{
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  right: 0;
  bottom: 0;
  margin-bottom: 20px;
  margin-right: 20px;
  margin-left: 35px;
  border-radius: 10px;
  position: fixed;
  z-index: 50;
}

@media (max-width: 700px)
{
  .back-icon{
    left: 0;
    margin-bottom: 15px;
    margin-left: 15px;
  }
}

.back-icon:hover{
  cursor: pointer;
  transform: scale(1.05);
  transition: all 0.2s;
}
</style>
